<template>
  <div class="stationLogin">
    <img class="bg" src="../../assets/img/womensDay/bg.png" alt="">
    <div class="footer">
        <div class="loginContainer">
          
              <div class="getCode">
                <!-- <p class="fontsTips">您有5元现金待领取！填写手机号下载 听见广播APP登录获得更多！</p> -->
                <div class="telAndcode">
                  <div class="tel">
                    <input id='tel' type="tel"  placeholder="请输入11位手机号" class="telInput" maxlength="11"  v-model="tel" @input="setButtonStatus" > 
                  </div>
                  <div class="code">
                    <!-- @blur="isBlur" -->
                    <input  type="tel" placeholder="请输入短信验证码"  class="codeInput"  v-model="code" maxlength="6"  >
                    <span class="sendCode"    v-if="telLength !='1' && sending"  style="background:rgba(220,220,220,1);;color:rgba(0, 0, 0, .5);">发送验证码</span>
                    <span class="sendCode" @click.stop="sendCode()"    v-if="telLength == '1' && sending" :disabled="isDisabled"  style="background:rgba(255, 108, 129, 1);color:rgba(255, 255, 255, 1);">发送验证码</span>
                    <span v-if="!sending" style="background:rgba(255,108,129,1);color:#fff;">{{second}}s</span> 
                  </div>
                </div>
            </div>
            <div class="reallogin">
              <p  v-if="!isdis"  >
                  <span class="button1">确 &nbsp;定</span>
              </p>
              <p  @click.stop="reallogin()"  v-if="isdis" :disabled="isDisabled1">
                  <span class="button1 button2">确  &nbsp;定</span>
              </p>
            </div>
    
        </div>
      
    </div>
  
  </div>

  
</template>

<script>
import { Toast } from 'mint-ui';
import share from '../../assets/js/common/share.js';
import shareMsg from '../../assets/js/common/shareConfig.js';
export default {
  name: 'login',
  data(){
    return{
      isDisabled:false,
      isDisabled1:false,//登录
      isdis:false,
      sending:true,
      second:60,
      tel:'',
      code:'',
      returnUrl:'',
      is_live:'',
      chnnelId:'',
      city:'',
      cover_img:'',
      mp4Url:'',
      title:'',
      pro:'',
      telLength:'',
      //视频ID
      ncp_id:'',
      from2:'',//区分是否在公众号
      wxCode:'',//授权
      invite_token:'',
      loginUrl:'',
      videoId:'',
    }
  },

  methods:{
    setButtonStatus() {
        if(this.tel.length == 11){
            this.telLength = '1';
        }else if(this.tel.length < 11){
            this.telLength = '';
        }
        if(this.code == '' || this.tel =='') {
            this.isdis = false;
        }else{
            this.isdis=true;
        }
    },
    clearTel:function(){
        this.tel = '';
        this.telLength = '';
    },
    //发送验证码
    sendCode(){
      if (!this.sending) {
        return
      }
      let self=this;
      var reg=/^1\d{10}$/;
      if (this.tel=='' || this.tel==undefined) {
          Toast("请输入手机号")
           this.sending=true;
           this.isDisabled=true;
           return;
      }else if(!reg.test(this.tel)) {
           Toast("请输入正确的手机号")
           this.sending=true;
           this.isDisabled=true;
           return;
      }else{
        this.sending=false;
        this.isDisabled=true;
        this.timeDown();
        let self=this;
        this.api2.post(this.cbct.https()+'/v2/jubilee/send-code', this.qs.stringify({
            mobile:this.tel
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){ 
                
                    Toast({
                      message: '发送成功',
                      position: 'center',
                      duration: 5000
                  }); 
                   
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
         }
        ).catch((error)=>{console.log(error);})
      }
    },
    getopendId(){
       this.api2.post(this.cbct.https()+'/h5/base/oauth', this.qs.stringify({
         code:this.wxCode
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
              this.cbct.setCookie('opendId',response.d.openid); 
              this.opendId =response.d.openid
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
         }
        ).catch((error)=>{console.log(error);})
    },
    wxCallback1(){
      var self = this;
       this.api2.post(this.cbct.https()+'/h5/snsapi/base', this.qs.stringify({
        type:'other',
        redirect_url:window.location.href,
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
             
              window.location.href=response.d.url
              // if(self.from1!='app'){
              //   if (self.$route.query.state) {
              //     self.cbct.setCookie('hostToken',self.$route.query.state);
              //     self.token1=self.$route.query.state
              //   }
              // }
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
         }
        ).catch((error)=>{console.log(error);})
    },
    reallogin(){
          let self=this;
          this.isDisabled1=true;
          setTimeout(()=>{
            self.isDisabled1=false;
          },250)
          this.api2.post(this.cbct.httpslaxin()+'/h5/fission/login', this.qs.stringify({
                phone:this.tel,
                code:this.code,
                source:12,
                // invite_token:this.invite_token,
              })).then((response)=>{
                  if(response.c == this.cbct.code.successRes){ 
                        // Toast({
                        //   message: '正在登录',
                        //   position: 'center',
                        //   duration: 1000
                        // }); 
                        this.cbct.setCookie('token2',response.d.token);
                        this.cbct.setCookie('salt2',response.d.salt);
                        this.cbct.setCookie('ds_token',response.d.ds_token);
                        this.$router.replace({path:'./womensDayDetails?videoId='+self.videoId});
                        
                }else if(response.c == this.cbct.code.noLogin){
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 5000
                    });
                    timing.time();
                }else if(response.c == this.cbct.code.raleNoLogin){
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 5000
                    });
                }else{
                    Toast({
                        message: response.m,
                        position: 'center',
                        duration: 5000
                    });
                }
                
            }
            ).catch((error)=>{console.log(error);})
           
    },
    timeDown(){
        this.isDisabled=true;
        let result=setInterval(()=>{
        --this.second;
        if (this.second<0) {
          clearInterval(result);
          this.sending=true;
          this.isDisabled=false;
          this.second=60;
        }
      },1000)
    },
  },
  created(){
    $('html').css('min-height','100%');
    document.body.style.background="rgba(255, 243, 234, 1)";
    // $('html').css('background','rgba(255, 243, 234, 1)');

    let self = this;
    if(this.$route.query.code){
      this.wxCode = this.$route.query.code
    }
     if(this.$route.query.videoId){
     this.videoId = this.$route.query.videoId;
    }
    // if ( this.cbct.getCookie('invite_token')) {
    //   this.invite_token = this.cbct.getCookie('invite_token')
    // }
    if (self.$route.query.code) {
      self.wxCode=self.$route.query.code
      self.getopendId()
    }else{
      self.wxCallback1()
    }
    this.timing.time();
    // 判断是否为充值
    self.ncp_id = self.cbct.getCookie('ncpId');
    if (self.$route.query.returnUrl !='' || self.$route.query.returnUrl!=undefined) {
          self.returnUrl=self.$route.query.returnUrl;
    }
 
 
  },
  mounted(){
    $('title').html('登录页面');
    var src = this.cbct.https().split('channels-')[1].split('.')[0];
    if(src != ''&& src != undefined){
        if(src != 'dev' && src != 'test'){
            src = '';
        }else{
            src = src+'.';
        }
    }
    this.loginUrl = 'http://channels.h5.'+src+'cbct.cn/newYearVideoPage',
    share.share(this.loginUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
    share.QQshare(this.loginUrl,'听见广播 云贺新春','全国电台陪您一起过新年','http://img001.seefm.com.cn/image/newYearShare.jpg');
  },
  components: {
  },
  watch:{
    tel(n,o){
      var reg=/^1\d{10}$/
      if (n=='' || n== undefined || n==null) {
        this.isdis=false;
      }else if( !reg.test(n)){
        this.isdis=false;
      }else if(reg.test(n) != '' && this.code !=''){
        this.isdis=true;
      }
    },
    code(n,o){
       var reg=/^1\d{10}$/
       if (n=='' || n== undefined || n==null) {
        this.isdis=false;
      }else if( !reg.test(this.tel)){
        this.isdis=false;
      }
      else if(n != '' && reg.test(this.tel) !=''){
        this.isdis=true;
      }
    }
  },
}


</script>

<style scoped lang="scss">
   .stationLogin{
        width: 100%;
        height: 100vh;
        background: rgba(255, 174, 172, 1);
        box-sizing: border-box;
      //  background: url('../../assets/img/womensDay/bg.png') no-repeat 0 0;
      //  background-size:100% auto ;
        // overflow: hidden;
        .bg{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height:auto;
          z-index: 1;
        }
        .footer{
          position: absolute;
          bottom:0;
          height: 4.2rem;
          width: 100%;
          left:0;
          z-index: 3;
        }
        .loginContainer{
          width: 100%;
          box-sizing: border-box;
          // position: absolute;
          // top: 0.98rem;
          // z-index: 20;
          .getCode{
            .fontsTips{
              font-size:0.26rem;
              font-weight:500;
              color:rgba(193,247,255,.7);
              padding: 0 1.56rem;
              line-height: 1.3;
              margin-bottom: 0.44rem;
            }
            .telAndcode{
              .tel ,.code{
                width: 100%;
                box-sizing: border-box;
                padding: 0 0.3rem;
                font-size: 0.28rem;
              
                input{
                  background:rgba(255,255,255,1);
                  border-radius:.44rem ;
                }
              }
              input{  
                  padding: 0.22rem 0;
                  width: 100%;
                  height: 0.88rem;
                  padding-left: 0.4rem;
                  box-sizing: border-box;
                  outline: none;
                  border-radius:0.16rem;
                  color:rgba(0,0,0,1);
                  font-size:0.28rem;
                  font-weight:500;
                  
                  line-height:0.44rem;
              }
              input::-webkit-input-placeholder {
                font-weight:500;
                color:rgba(0,0,0,.3);
              }
              .code{
                margin-top: 0.48rem;
                display: flex;
                .codeInput{
                  text-align: left;
                  width: 4.5rem;
                  box-sizing: border-box;
                  margin-right:.16rem;
                }
                span{
                    display: block;
                    width: 2.24rem;
                    height: 0.88rem;
                    line-height: 0.88rem;
                    box-sizing: border-box;
                    background:rgba(255, 196, 21, 1);
                    border-radius:0.16rem;
                    text-align: center;
                    font-weight:500;
                    font-size:0.28rem;
                     border-radius:.44rem ;
                    color: rgba(161, 46, 11, 1);
                  }
              }
            }
          }
          .reallogin{
            margin-top: 0.38rem;
            font-size: 0.28rem;
            p{
              padding:0 0.3rem;
              font-weight:500;
              // color:rgba(91,72,36,.49);
              margin: auto;
              // border-radius:0.44rem;
              .button1{
                display: inline-block;
                width: 100%;
                height: auto;
                font-weight:500;
                font-size:0.32rem;
                padding: 0.28rem 0;
                line-height: 1;
                background:rgba(220,220,220,1);
                color:rgba(0,0,0,0.5);
                border-radius:.44rem;
              }
              .button2{
                color:#FFF;
                background:rgba(255, 108, 129, 1);
               // box-shadow:0px -1px 0.16rem 0px rgba(245,166,35,0.95);
                // border-radius:0.44rem;
                // border:1px solid;
               // border-image:linear-gradient(180deg, rgba(255,203,119,1), rgba(247,107,28,1)) 1 1;
              }
              
            }
          }
         
        }
       
       
   }
 
</style>

